@if (isInit) {
    <div class="question-page">
        <div class="question-page__body">
            @for (section of activePage.sections; track section) {
                <div class="question-section">
                    @if (!section.disabled && !section.options?.hidden) {
                        <div>
                            <div class="question-section__head">
                                @if (translateService.keyExists('section.' + section.sectionCode + '.title')) {
                                    <h2 class="section-title m-0">
                                        {{ 'section.' + section.sectionCode + '.title' | translate }}
                                    </h2>
                                }
                                <!-- nosemgrep: java.lang.security.audit.xss.jsf.autoescape-disabled.autoescape-disabled -->
                                @if (translateService.keyExists('section.' + section.sectionCode + '.infoType')) {
                                    <span
                                        class="material-symbols-outlined icon-md cursor-help text-color-secondary"
                                        [pTooltip]="getTooltipContent(section.sectionCode)"
                                        [escape]="false">
                                        info
                                    </span>
                                }
                            </div>
                            <div class="card mb-0 overflow-hidden">
                                @if (section.options?.isHighlighted) {
                                    <p-message severity="info" class="mb-3">
                                        <ng-template #icon>
                                            <span class="material-symbols-outlined icon-md" aria-hidden="true"
                                                >family_star</span
                                            >
                                        </ng-template>
                                        {{ 'common.highlighted-label' | translate }}
                                    </p-message>
                                }
                                <div class="section-container">
                                    @if (translateService.keyExists('section.' + section.sectionCode + '.label')) {
                                        <span>
                                            {{ 'section.' + section.sectionCode + '.label' | translate }}
                                        </span>
                                    }
                                    <div [ngClass]="section.options?.isHorizontalQuestion ? 'flex' : ''">
                                        @for (
                                            question of config.questionsPerPage[activePage.pageCode][
                                                section.sectionCode
                                            ];
                                            track question
                                        ) {
                                            <div class="flex-grow-1">
                                                @if (!externalUpdates.has(question.questionCode)) {
                                                    <app-question
                                                        [question]="question"
                                                        [domainPerCode]="config.domainPerCode"
                                                        [orgId]="organizationId"
                                                        [questionnaireId]="questionnaireId"
                                                        [locale]="locale"
                                                        [currentEntityFte]="currentEntityFte">
                                                    </app-question>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
